/**
 * Path user admin table
 */
export const usersAdminPath = '/users';